import { ShieldAlert, ShieldCheck } from '@music-vine/cadence/icons';
export const SafelistedChannelsIcon = ({
  safelistedChannelCount,
  hasSafelistPermission,
  overduePaymentId
}: {
  safelistedChannelCount: number;
  hasSafelistPermission: boolean;
  overduePaymentId?: string;
}) => {
  if (overduePaymentId) {
    return <ShieldAlert className="size-4 text-red-600 dark:text-red-400" />;
  }
  if (safelistedChannelCount > 0 && hasSafelistPermission) {
    return <ShieldCheck className="size-4 text-green-600 dark:text-green-400" />;
  }
  return null;
};